export default __webpack_public_path__ + "static/media/image-ph-health-briefing-w.ddf54309.webp";